import { Module, Menu } from './../services/menu/responses/menu.response';
import { ActualSubmenu } from './../menu-nav-bar/interfaces/actual-submenu.interface';
import {
  Component,
  Input,
  OnInit,
  HostListener,
  ElementRef,
  ViewChild,
  EventEmitter,
  Output,
} from '@angular/core';
import { ClienteService } from 'src/app/shared/services/cliente/cliente.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu-dropdown-nav-bar',
  templateUrl: './menu-dropdown-nav-bar.component.html',
  styleUrls: ['./menu-dropdown-nav-bar.component.scss'],
})
export class MenuDropdownNavBarComponent implements OnInit {
  MOBILE_WIDTH = 780;
  innerWidth: number;

  MAX_SUBMENU = 4;

  @Input() mobileWidth: string = '100vw';
  @Input() actualSubmenu: ActualSubmenu = null;
  @Input() modules: Module[] = [];
  menus: Menu[] = [];

  filteredModules: Module[] = [];
  filteresMenus: Menu[] = [];

  @Output() onSubmenuRoute = new EventEmitter();

  constructor(private clientS: ClienteService, private router: Router) {}

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
    if (this.actualSubmenu) {
      this.menus = this.actualSubmenu.menu.module.menu || [];
    } else {
      this.menus =
        this.modules && this.modules.length > 0 ? this.modules[0].menu : [];
    }
    this.filteredModules = this.modules;
    this.filteresMenus = this.menus;
  }

  filter(search: string) {
    if (search.trim() === '') {
      this.filteredModules = this.modules;
      this.filteresMenus = this.menus;
    } else {
      search = this.lowerWithoutAccent(search);

      this.filteredModules = this.modules
        .map((mod) => {
          const menu = this.lowerWithoutAccent(mod.servicio).includes(search)
            ? mod.menu
            : this.filterMenus(mod.menu, search);
          return { ...mod, menu };
        })
        .filter((mod) => mod.menu.length > 0);

      this.filteresMenus = this.filterMenus(this.menus, search);

      if (this.filteredModules.length > 0) {
        this.changeMenus(this.filteredModules[0]);
      }
    }
  }

  filterMenus(menus: Menu[], search: string): Menu[] {
    return menus.filter((menu) => {
      return (
        this.lowerWithoutAccent(menu.nombre).includes(search) ||
        menu.sub_menu.some((sm) =>
          this.lowerWithoutAccent(sm.title).includes(search)
        )
      );
    });
  }

  lowerWithoutAccent(value: string): string {
    return value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  changeMenus(module: Module) {
    this.menus = module.menu;
    this.filteresMenus = module.menu;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  isDesktop() {
    return this.innerWidth >= this.MOBILE_WIDTH;
  }

  getModuleFirstRoute(item: Module): string {
    if (item.menu.length > 0) {
      for (let i = 0; i < item.menu.length; i++) {
        if (item.menu[i].sub_menu.length > 0) {
          return item.menu[i].sub_menu[0].url;
        }
      }
    }
    return '';
  }

  getMenuFirstRoute(item: Menu) {
    if (item.sub_menu.length > 0) {
      return item.sub_menu[0].url;
    }
    return '';
  }

  collapseMenu() {
    this.onSubmenuRoute.emit();
  }
  auditoria(url: any) {
    const usuario = JSON.parse(
      localStorage.getItem('AdminImplementos.usuario')
    );
    const { codEmpleado, codUsuario, nombre } = JSON.parse(usuario);
    const [, app, modulo, menu1] = url.split('/');

    const params = {
      codEmpleado,
      codUsuario,
      user: nombre,
      app,
      modulo,
      menu: menu1 ? menu1 : '',
      plataforma: 'web',
    };

    this.clientS.guardaAuditoria(params).subscribe();
  }
}
